import { computeTimerPhase, type IntervalTimerState } from '@gymboard/types'

export type TimerDisplayKey = 'ready' | 'work' | 'rest' | 'done'

/** How long "DONE" stays on screen after the last round. */
export const DONE_LINGER_MS = 5000

/**
 * What the TV's interval-timer overlay shows at `now` (server-corrected ms).
 * Before `startedAt` it counts down the get-ready seconds; after the last
 * round it shows DONE for DONE_LINGER_MS and then hides.
 */
export function timerDisplay(timer: IntervalTimerState | null, now: number) {
  if (!timer) return null
  const p = computeTimerPhase(timer, now)
  const finishedFor = p.phase === 'done' ? now - (timer.startedAt + p.totalMs) : 0
  const getReady = now < timer.startedAt
  const key: TimerDisplayKey = getReady ? 'ready' : p.phase
  const seconds = getReady
    ? Math.ceil((timer.startedAt - now) / 1000)
    : Math.ceil(p.remainingMs / 1000)
  const progress = getReady || p.phaseMs === 0 ? 1 : p.remainingMs / p.phaseMs
  return {
    visible: finishedFor < DONE_LINGER_MS,
    key,
    seconds,
    progress,
    round: p.round,
    rounds: p.rounds,
  }
}
